import React from 'react';
import styled from 'styled-components';
import ModalCenter from '@/common/components/modal/ModalCenter';
import { Button } from '@/common/components/button/Button';
import { semanticColors } from '@/common/styles/colorTokens';

interface ProfileDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  isUpdating: boolean;
}

const ProfileDeleteModal: React.FC<ProfileDeleteModalProps> = ({
  isOpen,
  onClose,
  onDelete,
  isUpdating,
}) => {
  return (
    <ModalCenter
      isOpen={isOpen}
      onClose={onClose}
      title="프로필 이미지 삭제"
      maxWidth="400px"
    >
      <ModalContentContainer>
        <ModalDescription>
          프로필 이미지를 삭제하시겠습니까?<br/>
          삭제된 이미지는 복구할 수 없습니다.
        </ModalDescription>
        <ModalButtonContainer>
          <Button
            $variant="outline"
            $size="md"
            onClick={onClose}
            disabled={isUpdating}
            style={{ flex: 1 }}
          >
            취소
          </Button>
          <Button
            $variant="destructive"
            $size="md"
            onClick={onDelete}
            disabled={isUpdating}
            style={{ flex: 1 }}
          >
            {isUpdating ? '삭제 중...' : '삭제하기'}
          </Button>
        </ModalButtonContainer>
      </ModalContentContainer>
    </ModalCenter>
  );
};

const ModalContentContainer = styled.div`
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const ModalButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
`;

const ModalDescription = styled.div`
  color: ${semanticColors.text.secondary};
  line-height: 1.6;
  text-align: center;
  margin: 0;
  font-size: 0.9rem;
`;

export default ProfileDeleteModal;
